export const TraceMessages = {
  existingUserFolderFound: (id: string, tenantId: string) =>
    `Existing 'My Views' folder found with id ${id} on tenant ${tenantId}`,
  indexedDBCacheHit: (key: string) => `IndexedDB cache hit for key: ${key}`,
  indexedDBCacheMiss: (key: string) => `IndexedDB cache miss for key: ${key}`,
  indexedDBCacheExpired: (key: string) => `IndexedDB cache expired for key: ${key}`,
  indexedDBCacheUpdate: (key: string) => `IndexedDB cache updated for key: ${key}`,
  dropdownDataKeyMissing: (key: string) => `Dropdown data key is missing: ${key}`,
  dropdownDataFetchError: (key: string) => `Error fetching dropdown data for key: ${key}`,
};
